export default "__VITE_ASSET__33HuCXE$__"